module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-bored.2bf06a0a.png";